/**
 * @generated SignedSource<<d2d537118a9b8b085d0a8a02378ddd1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePreferredTimezone_viewer$data = {
  readonly settings: {
    readonly timezonePreferences: {
      readonly preferredTimezone: {
        readonly timezone: {
          readonly name: string;
        };
      };
    };
  };
  readonly " $fragmentType": "usePreferredTimezone_viewer";
};
export type usePreferredTimezone_viewer$key = {
  readonly " $data"?: usePreferredTimezone_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePreferredTimezone_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePreferredTimezone_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimezonePreferences",
          "kind": "LinkedField",
          "name": "timezonePreferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserTimezone",
              "kind": "LinkedField",
              "name": "preferredTimezone",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeZone",
                  "kind": "LinkedField",
                  "name": "timezone",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d5d47fec371c0b7a764e657f3b6acf03";

export default node;
